import type { BranchKey, WorkspaceKey } from '@festina-life/api'
import { ErrorMessage } from '@festina-life/components'
import { useTranslate } from '@festina-life/ui/hooks'
import { SimpleModal } from '@festina-life/ui/structure'
import { useId } from 'react'

import type { WorkspaceCreateOrUpdateInput } from '../../uiModels/workspace/types'
import { useCreateWorkspace } from './useCreateWorkspace'
import { WorkspaceForm } from './WorkspaceForm'

type Props = {
  onCreated: (workspaceKey: WorkspaceKey) => void
  baseBranch: BranchKey
  isOpen: boolean
  onCancel: () => void
}

export const WorkspaceCreationModal = ({
  onCreated,
  baseBranch,
  isOpen,
  onCancel,
}: Props) => {
  const { mutateAsync, isPending, error } = useCreateWorkspace(baseBranch)
  const translate = useTranslate()
  const formId = useId()

  const initialValues = {
    name: '',
    branchKey: baseBranch,
  } satisfies WorkspaceCreateOrUpdateInput

  const handleSubmit = (values: WorkspaceCreateOrUpdateInput) =>
    mutateAsync(values).then(onCreated)

  return (
    <SimpleModal
      title={translate('workspaceCreationModal.title', {
        branchName: baseBranch.name,
      })}
      isOpen={isOpen}
      acceptConfiguration={{
        formId,
        label: translate('create'),
        loading: isPending,
      }}
      closeConfiguration={{ onClose: onCancel, label: translate('cancel') }}
      bodyOuterClassName="w-md"
    >
      <ErrorMessage error={error} />
      <WorkspaceForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        formId={formId}
      />
    </SimpleModal>
  )
}
